import React, { forwardRef } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import ru from "date-fns/locale/ru";
import "react-datepicker/dist/react-datepicker.css";
import { getMonth, getYear } from "date-fns";
import range from "lodash/range";

registerLocale("ru", ru);

const CustomDatePicker = ({
  selected,
  onChange,
  showYearDropdown,
  scrollableYearDropdown,
  yearDropdownItemNumber,
  dateFormat,
  placeholderText,
  locale = "ru",
  showMonthYearPicker,
  customInput,
  showYearPicker,
  ...props
}) => {
  const years = range(2000, getYear(new Date()) + 10, 1);
  const months = [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь",
  ];

  const DefaultCustomInput = forwardRef(
    ({ value, onClick, placeholder }, ref) => (
      <div
        onClick={onClick}
        ref={ref}
        className="position-relative cursor"
        style={{ width: "100%" }}
      >
        <input
          readOnly
          className="input-control"
          value={value || placeholder || ""}
          placeholder={placeholder}
          style={{ backgroundColor: "white", fontSize: "12px" }}
        />
      </div>
    )
  );

  return (
    <DatePicker
      selected={selected}
      onChange={onChange}
      showYearDropdown={showYearDropdown}
      scrollableYearDropdown={scrollableYearDropdown}
      yearDropdownItemNumber={yearDropdownItemNumber}
      dateFormat={dateFormat || "yyyy-MM-dd"}
      placeholderText={placeholderText}
      locale={locale}
      showMonthYearPicker={showMonthYearPicker}
      showYearPicker={showYearPicker}
      customInput={customInput || <DefaultCustomInput />}
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div
          style={{
            margin: 10,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button
            className="btn btn-sm btn-icon btn-light-primary me-2"
            onClick={decreaseMonth}
            disabled={prevMonthButtonDisabled}
          >
            {"<"}
          </button>
          <select
            className="form-select form-select-sm form-select-solid me-2"
            value={getYear(date)}
            onChange={({ target: { value } }) => changeYear(value)}
            style={{ width: "90px" }}
          >
            {years.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <select
            className="form-select form-select-sm form-select-solid me-2"
            value={months[getMonth(date)]}
            onChange={({ target: { value } }) =>
              changeMonth(months.indexOf(value))
            }
            style={{ width: "110px" }}
          >
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <button
            className="btn btn-sm btn-icon btn-light-primary"
            onClick={increaseMonth}
            disabled={nextMonthButtonDisabled}
          >
            {">"}
          </button>
        </div>
      )}
      {...props}
    />
  );
};

export default CustomDatePicker;
